module.exports = __webpack_public_path__ + "img/gmri-otolith-id-13.773339ca.png";